import { freeAccess } from "utils/constants";

const parse_user_info = (infoStr: string) => {

    const resetPassword = 'https://www.yisumatica.org.il/frontend/user/change_password/';

    const n6 = infoStr.search(resetPassword)

    

    if (n6 !== -1) {
        // transfer user to reset password
        const n7  = infoStr.search(`" method="post" validate-form="true"`);
        const num = infoStr.slice(n6 + resetPassword.length, n7);
        localStorage.clear();
        window.location.assign(`https://www.yisumatica.org.il/frontend/user/change_password/${ num }`)
      //  return;
        //
    }


    let name                  = '', 
        email                 = '', 
        realEmail             = '', 
        role                  = '', 
        logedIn               = '', 
        semelMosad            = '', 
        plus                  = false, 
        gradeAccess           = [] as any[],
        subscriptionExpired   = false, 
        subscriptionExpiresAt = '';

        const parts = infoStr.split('&').reduce<Record<string,string>>((acc, chunk) => {
          if (!chunk) return acc;
          const [rawKey, ...rest] = chunk.split('=');
          if (!rawKey) return acc;
          const key = rawKey.includes('?') ? rawKey.split('?').pop() || rawKey : rawKey;
          try {
            acc[key.trim()] = decodeURIComponent(rest.join('='));
          } catch (e) {
            // If decodeURIComponent fails, use the raw value (might already be decoded)
            acc[key.trim()] = rest.join('=');
          }
          return acc;
        }, {});

        name      = parts['name'] ?? '';
        realEmail = parts['mail'] ?? '';
        email     = (freeAccess && (!realEmail.length || realEmail === 'guest@yisumatica.org.il')) ? 'user@user.user' : realEmail;
        role      = (parts['user'] ?? '') === 'student' ? 'student' : 'teacher';
        semelMosad = parts['semel_mosad'] ?? parts['semelMosad'] ?? parts['semelMossad'] ?? '';
         
          // if user doesnt have email but does have semel mosad - make email equal semel mosad
        if (!email.length && !!semelMosad.length) {
          email = semelMosad
        }
          
        // if no email and no semel mosad - user is not loggedin
        logedIn = !!email.length ? 'true' : 'false';

        if ( !email.length ) {
          email = 'guest@yisumatica.org.il';
          name  = 'guest'
        }

     // delete 99999999 from semel mosad string if exists
    let semelMosadArr = semelMosad.split(/[,\s]+/).filter(Boolean)
     const index       = semelMosadArr.indexOf('99999999');
     if (index > -1) {
      semelMosadArr.splice(index, 1);
     }
     const semelMosatStr = semelMosadArr.join();

    return {
        name:                  name,
        email:                 email,
        role:                  role,
        logedIn:               logedIn,
        semelMosad:            semelMosatStr,
        plus:                  plus,
        gradeAccess:           gradeAccess,
        subscriptionExpired:   subscriptionExpired,
        subscriptionExpiresAt: subscriptionExpiresAt,
        userFoundInTables:     [],
        userExists:            false,
    }

}

export default parse_user_info;